<template>
  <IconButton
    v-if="shouldShowWishlistButton"
    :icon="useNewIcon ? newIcon : icon"
    class="wishlist-button"
    :class="classes"
    @click="toggleWishList"
  >
    <span class="u__visually-hidden">{{ label }}</span>
  </IconButton>
</template>

<script>
import { mapState } from "vuex";
import IconButton from "@/components/IconButton.vue";
import { addToWishlistEvent } from "@/helpers/events.js";
import { getFeatureToggles } from "@/helpers/featureToggles.js";

export default {
  name: "WishlistButton",
  components: {
    IconButton,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      action: "add",
    };
  },
  computed: {
    ...mapState("auth", ["customer"]),
    ...mapState("product", ["wishlist"]),
    classes() {
      return {
        "wishlist-button--light": this.light === true,
      };
    },
    shouldShowWishlistButton() {
      const customerId = this.customer.id;
      if (!customerId) {
        return false;
      }

      return true;
    },
    icon() {
      if (this.action !== "add") {
        return "save-selected";
      }

      return "save";
    },
    newIcon() {
      if (this.action !== "add") {
        return "heart-filled";
      }

      return "heart-outline";
    },
    useNewIcon() {
      const { useNewIcon = false } = getFeatureToggles();
      return useNewIcon;
    },
    productInWishlist() {
      return this.wishlist.includes(this.productId);
    },
    label() {
      if (this.action === "add") {
        return "Save";
      }

      return "Saved";
    },
    productId() {
      return this.product.id;
    },
  },
  watch: {
    wishlist() {
      this.checkInitialProductState();
    },
  },
  mounted() {
    this.checkInitialProductState();
  },
  methods: {
    async toggleWishList() {
      this.apiCall();

      if (this.action === "add") {
        this.action = "remove";
      } else {
        this.action = "add";
      }
    },
    async apiCall() {
      const customerId = this.customer.id;
      const action = this.action.toLowerCase();

      if (!customerId) {
        return null;
      }

      await fetch(
        `${process.env.RATANDBOA_NODE_APP_URL}/customer/wishlist/${action}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            customerId: customerId,
            productId: this.productId,
          }),
        }
      );
      if (action === "add") {
        addToWishlistEvent({ product: this.product });
      }
    },
    checkInitialProductState() {
      if (this.productInWishlist) {
        this.action = "remove";
      } else {
        this.action = "add";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wishlist-button--light {
  color: $color-light;
}

.wishlist-button.button--icon {
  padding: 12px;

  ::v-deep(.icon) {
    font-size: 20px;
    margin-right: 0;
  }
}
</style>
